var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"no-fade":_vm.noFade,"no-wrap":_vm.noWrap,"opacity":_vm.opacity,"rounded":_vm.rounded,"show":_vm.loading || _vm.show,"spinner-type":_vm.spinnerType,"variant":_vm.color,"z-index":_vm.zIndex}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }